export const CONSOLIDATED_MIS_REQUEST = 'CONSOLIDATED_MIS_REQUEST';
export const CONSOLIDATED_MIS_SUCCESS = 'CONSOLIDATED_MIS_SUCCESS';
export const CONSOLIDATED_MIS_FAIL = 'CONSOLIDATED_MIS_FAIL';
